<!-- Vehicle data and logo -->
<div class="input-group mb-3">
   <div class="input-group-prepend">
      <img class="logo" [src]="state.logosUrl + image" width="40px" style="margin-right: 10px; margin-left: 10px;"/>
      <span style="min-width: 100px; max-width: 140px; font-weight: bold; color: #007bff;">{{Vehicle}}</span>
   </div>
</div>
